import React, { useState } from "react";
import classes from "./Posts.module.css";
import { IoEyeSharp } from "react-icons/io5";
import { FaUserAlt } from "react-icons/fa";
import { BiCategory } from "react-icons/bi";
import Modal from "react-bootstrap/Modal";
import PostDetailModal from "./PostDetailModal";
import { formatEditAt } from "../../utils/editAudit";

const Posts = ({
  postsList,
  handlePostDelete,
  showPendingPosts,
  showSliderPosts,
  handlePostApproval,
  handleToggleSlider,
  deleteLoading,
  selectedIds = new Set(),
  onToggleSelect,
}) => {
  const [selectedPost, setSelectedPost] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [postToDelete, setPostToDelete] = useState(null);

  const handleViewPost = (post) => {
    setSelectedPost(post);
    setShowDetailModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
    setSelectedPost(null);
  };

  const confirmDelete = () => {
    if (!postToDelete) return;
    handlePostDelete(postToDelete);
    setPostToDelete(null);
  };

  return (
    <>
      {postsList &&
        postsList.map((post, index) => {
          return (
            <div className={classes.postsList + " mb-4"} key={post.id || index}>
              <div className={classes.selectCheckbox}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selectedIds.has(post.id)}
                  disabled={deleteLoading}
                  onChange={() => onToggleSelect?.(post.id)}
                  aria-label={`Select ${post.title || "post"}`}
                />
              </div>
              <div className="d-flex">
                <div className={classes.postListImage}>
                  <img src={post.thumbnail} alt="Thumbnail" />
                </div>
                <div className={classes.postDetails}>
                  <h4>
                    {post.title === "" ? "No Title" : post.title}
                    {post.is_slider && (
                      <span className="badge bg-info text-dark ms-2">
                        Slider #{post.slider_order ?? 0}
                      </span>
                    )}
                  </h4>
                  <div>
                    <div>{post.description}</div>
                    <div>
                      <FaUserAlt /> {post.uploader_details?.name}
                      <IoEyeSharp className="ms-2" /> {post.views}
                    </div>
                    <div>
                      <BiCategory /> {post.category}
                    </div>
                    {(post.last_edit_ip || post.last_edit_location || post.last_edit_by) && (
                      <div className={classes.lastEdit}>
                        Last edit:{" "}
                        <strong>{post.last_edit_ip || "—"}</strong>
                        {" · "}
                        <strong>{post.last_edit_location || "—"}</strong>
                        {post.last_edit_by ? ` · by ${post.last_edit_by}` : ""}
                        {post.last_edit_at
                          ? ` · ${formatEditAt(post.last_edit_at)}`
                          : ""}
                        {post.last_edit_action
                          ? ` · ${post.last_edit_action}`
                          : ""}
                      </div>
                    )}
                    {Array.isArray(post.reports) && post.reports.length > 0 && (
                      <div className="mt-1">
                        <span className="badge bg-danger">
                          {post.reports.length} report
                          {post.reports.length > 1 ? "s" : ""}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className={`ms-3 ${classes.postButtons}`}>
                <button
                  type="button"
                  className="btn btn-outline-primary me-2 mb-2"
                  disabled={deleteLoading}
                  onClick={() => handleViewPost(post)}
                >
                  View
                </button>
                {showPendingPosts && (
                  <button
                    className="btn btn-outline-success me-2 mb-2"
                    disabled={deleteLoading}
                    onClick={() => handlePostApproval(post)}
                  >
                    Approve
                  </button>
                )}
                {!showPendingPosts && (
                  <button
                    className={`btn me-2 mb-2 ${
                      showSliderPosts || post.is_slider
                        ? "btn-outline-warning"
                        : "btn-outline-info"
                    }`}
                    disabled={deleteLoading}
                    onClick={() => handleToggleSlider(post)}
                  >
                    {showSliderPosts || post.is_slider
                      ? "Remove from Slider"
                      : "Promote to Slider"}
                  </button>
                )}
                <button
                  className="btn btn-outline-danger mb-2"
                  disabled={deleteLoading}
                  onClick={() => setPostToDelete(post)}
                >
                  Delete
                </button>
              </div>
            </div>
          );
        })}
      <PostDetailModal
        show={showDetailModal}
        post={selectedPost}
        onHide={handleCloseModal}
      />
      <Modal
        show={!!postToDelete}
        onHide={() => setPostToDelete(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete{" "}
          <strong>{postToDelete?.title || "this post"}</strong>?
          <br />
          <span className="text-muted">
            This action cannot be undone. A full audit log entry will be saved.
          </span>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            disabled={deleteLoading}
            onClick={() => setPostToDelete(null)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            disabled={deleteLoading}
            onClick={confirmDelete}
          >
            Delete Video
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Posts;
